import React, { useMemo } from 'react'
import { SimpleSelect, SimpleSelectProps } from '../SimpleSelect/SimpleSelect'
import { Currency } from '../../../globalTypes'
import { Flag } from '../../misc/Flag/Flag'
import styled from 'styled-components'
import { AVAILABLE_CURRENCY } from '../../../constants'

const OptionStyled = styled.div`
  display: flex;
  align-items: center;
`

const FlagStyled = styled(Flag)`
  margin-right: 5px;
`

const mapCurrencyToFlag = {
  [Currency.CAD]: <FlagStyled code={'CA'} />,
  [Currency.EUR]: <FlagStyled code={'EU'} />,
  [Currency.RUB]: <FlagStyled code={'RU'} />,
  [Currency.USD]: <FlagStyled code={'US'} />,
}

type CurrencySelectOption = {
  id: Currency
  title: string
}

export type CurrencySelectProps = {
  value?: Currency
  list?: Currency[]
  onChange: (value?: Currency) => void
} & Omit<SimpleSelectProps<CurrencySelectOption>, 'options' | 'onChange'>

export const CurrencySelect: React.FC<CurrencySelectProps> = ({ list = AVAILABLE_CURRENCY, value, ...rest }) => {
  const options = useMemo(
    () =>
      list.map(currency => ({
        id: currency,
        title: currency,
      })),
    [list],
  )

  return (
    <SimpleSelect
      options={options}
      formatOptionLabel={data => (
        <OptionStyled>
          {mapCurrencyToFlag[data.id]}
          {data.id}
        </OptionStyled>
      )}
      value={value}
      {...rest}
    />
  )
}
